<template>
  <v-flex md4>
    <page-toolbar>
      <kendo-button icon="add" title="Add new" @click="addRecord" v-if="!isReadOnly">
      </kendo-button>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 145px)"
      :dataSource="dataSource"
      :editable="!isReadOnly && 'inline'"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :columns="columns"
    >
    </kendo-grid>
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '@/helpers/export-helper'
import {jsonDropDownEditor} from '@/helpers/kendo-editors'
import security from '@/mixins/security'

const $ = kendo.jQuery

export default {
  mixins: [security],
  mounted() {
    let grid = this.$refs.grid.kendoWidget()
    enableExportExcel(grid, '/api/heroux/Signator/exportToExcel', $('.page_toolbar-item'))
  },
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/Signator',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/heroux/Signator',
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/heroux/Signator',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/heroux/Signator',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'signatorId',
            fields: {
              signatorId: {type: 'number', defaultValue: -1},
              clientId: {type: 'number', defaultValue: () => this.clientId},
              name: {type: 'string', validation: {required: true}},
              title: {type: 'string', validation: {required: false}},
              authorizationLevel: {type: 'number', defaultValue: 1, validation: {required: true}},
              canBeDeleted: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
      }),
    }
  },
  methods: {
    addRecord() {
      let grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    curveDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'curveId',
        'curveName',
        '/api/heroux/Signator/getCreditCurve',
        {
          dataBound: function() {
            this.trigger('change')
          },
        },
        false,
      )(container, options)
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    columns() {
      return [
        {
          editable: !this.isReadOnly,
          command: [{name: 'edit'}],
          width: 40,
        },
        {
          field: 'name',
          title: 'Name',
          width: 132,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="name" required="required" type="text" class="k-input k-textbox" data-bind="value:name" />',
        },
        {
          field: 'title',
          title: 'Title',
          width: 82,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="title" type="text" class="k-input k-textbox" data-bind="value:title" />',
        },
        {
          field: 'authorizationLevel',
          title: 'Authorization Level',
          width: 82,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="authorizationLevel" required="required" type="text" class="k-input k-textbox" data-bind="value:authorizationLevel" />',
        },
        {
          editable: !this.isReadOnly,
          command: [{name: 'destroy', visible: dataItem => dataItem.canBeDeleted}],
          width: 40,
        },
      ].filter(c => c.editable !== false)
    },
  },
  components: {
    PageToolbar,
  },
}
</script>
